import { Grid } from '@mui/material';
import { Offers, Offer } from 'models';
import { StyledOfferCard, StyledGrid } from './PerkzStoreList.styles';

export interface PerkzStoreListProps {
  offers: Offers;
  onViewOffer: (offer: Offer) => void;
}

const PerkzStoreList = ({ offers, onViewOffer }: PerkzStoreListProps) => (
  <Grid container spacing={2} aria-label="Perkz list">
    {offers.map((offer, idx) => (
      <StyledGrid item xs={6} md={4} key={`offer-card-${idx + 1}`}>
        <StyledOfferCard displayBorder active offer={offer} onClick={onViewOffer} />
      </StyledGrid>
    ))}
  </Grid>
);

export default PerkzStoreList;
